import axios from "axios";
import config from "../config";
import { constructQueryString } from "../helpers/query-string";
import {
  FacetCategory,
  FacetType,
  IGetFacetsResponse,
  SkillsFacetsType,
} from "./facets.types";

const defaultLanguage = "en-gb";

export const GET_SKILLS_FACETS = "GET_SKILLS_FACETS";

export const GET_FACETS_CATEGORY_QUERY_KEY = "GET_FACETS_CATEGORY_QUERY_KEY";

export const GET_GENDER_FACET = "get-gender-facets";

export const GET_HnE_FACETS = "get-h-n-e-facets";

/**
 * @deprecated The method should not be used, use function with axios instead. The class will be removed in the future.
 */
export class FacetService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  getFacets({
    category,
    language = defaultLanguage,
  }: {
    category: FacetType;
    language?: string;
  }): Promise<IGetFacetsResponse> {
    const queryString = constructQueryString({
      categories: category,
      lang: language,
    });

    return fetch(`${this.url}/facets/categories${queryString}`).then((res) =>
      res.json()
    );
  }

  getFacetsCategories(
    categories: (FacetType | SkillsFacetsType)[]
  ): Promise<IGetFacetsResponse> {
    const queryString = new URLSearchParams([
      ...categories.map(
        (category: string) => ["categories", category],
        ["lang", defaultLanguage]
      ),
    ]);

    return fetch(`${this.url}/facets/categories?${queryString}`).then((res) => {
      if (res.status !== 200) throw Error(String(res.status));

      return res.json();
    });
  }
}

export function getFacetsCategories(
  categories: (FacetType | SkillsFacetsType | FacetCategory)[]
) {
  return axios.get(`${config.profileApiUrl}/facets/categories`, {
    params: {
      categories,
      lang: defaultLanguage,
    },
    paramsSerializer: {
      indexes: null,
    },
  });
}
